/* PrimeChemical Corp. — bloque de presencia: Hong Kong · Barcelona · Amsterdam
   v4 · 2026-09-15
   Inserta una seccion propia (banda oscura a sangre) justo despues de #people,
   con un globo de puntos girando en canvas, las tres ciudades marcadas en su
   latitud/longitud real y arcos de gran circulo entre ellas.
   Sin librerias, sin peticiones externas. Solo anade: no toca nada existente.
   Respeta prefers-reduced-motion y se pausa cuando no esta en pantalla. */
(function () {
  'use strict';

  /* Copia en los cuatro idiomas de la tienda. Evita a proposito la formula
     "Una ___." porque #people ya dice "Un equipo. Una mision." y repetirla
     dejaba tres frases calcadas en la misma pagina. */
  var T = {
    en: { k: 'PRIMECHEMICAL \u00b7 WHERE WE WORK',
          h: 'Hong Kong. Barcelona.<br>Amsterdam.',
          a: 'The same standard in all three.',
          s: 'Three cities, three time zones, one specification sheet \u2014 and a certificate of analysis behind every batch we release.' },
    es: { k: 'PRIMECHEMICAL \u00b7 D\u00d3NDE TRABAJAMOS',
          h: 'Hong Kong. Barcelona.<br>Amsterdam.',
          a: 'El mismo est\u00e1ndar en las tres.',
          s: 'Tres ciudades, tres husos horarios, una sola ficha de especificaci\u00f3n \u2014 y un certificado de an\u00e1lisis detr\u00e1s de cada lote que liberamos.' },
    fr: { k: 'PRIMECHEMICAL \u00b7 O\u00d9 NOUS TRAVAILLONS',
          h: 'Hong Kong. Barcelona.<br>Amsterdam.',
          a: 'Le m\u00eame standard dans les trois.',
          s: 'Trois villes, trois fuseaux horaires, une seule fiche de sp\u00e9cification \u2014 et un certificat d\'analyse derri\u00e8re chaque lot lib\u00e9r\u00e9.' },
    it: { k: 'PRIMECHEMICAL \u00b7 DOVE LAVORIAMO',
          h: 'Hong Kong. Barcelona.<br>Amsterdam.',
          a: 'Lo stesso standard in tutte e tre.',
          s: 'Tre citt\u00e0, tre fusi orari, una sola scheda di specifica \u2014 e un certificato di analisi dietro ogni lotto rilasciato.' }
  };

  function copy() {
    var l = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
    return T[l] || T.en;
  }

  var CITIES = [
    { id: 'hk', name: 'Hong Kong', lat: 22.32, lon: 114.17, coord: '22.3°N 114.2°E' },
    { id: 'bcn', name: 'Barcelona', lat: 41.39, lon: 2.17, coord: '41.4°N 2.2°E' },
    { id: 'ams', name: 'Amsterdam', lat: 52.37, lon: 4.90, coord: '52.4°N 4.9°E' }
  ];

  var CSS = ''
    + '.pcc-globe{position:relative;background:#061630;color:#fff;overflow:hidden;isolation:isolate}'
    + '.pcc-globe:before{content:"";position:absolute;inset:0;background:radial-gradient(120% 90% at 78% 45%,rgba(37,134,255,.30),transparent 62%),radial-gradient(70% 60% at 10% 10%,rgba(12,203,235,.14),transparent 70%);pointer-events:none}'
    + '.pcc-globe-inner{position:relative;z-index:1;max-width:1180px;margin:0 auto;padding:clamp(64px,7vw,104px) 24px;display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:clamp(24px,4vw,56px);align-items:center}'
    + '.pcc-globe-kicker{display:block;font-family:var(--font-m,ui-monospace,monospace);font-size:11px;font-weight:700;letter-spacing:.22em;color:#6FC4FF;margin-bottom:22px}'
    + '.pcc-globe h2{font-size:clamp(30px,4.2vw,54px);line-height:1.06;margin:0 0 10px;letter-spacing:-.015em;color:#fff}'
    + '.pcc-globe h2 em{font-style:normal;display:block;color:#3FA9FF;margin-top:.26em;font-size:.6em;line-height:1.2;letter-spacing:-.005em}'
    + '.pcc-globe-sub{margin:20px 0 0;max-width:34ch;color:rgba(224,239,255,.66);font-size:15.5px;line-height:1.6}'
    + '.pcc-globe-cities{list-style:none;margin:34px 0 0;padding:0;display:flex;flex-direction:column;gap:2px}'
    + '.pcc-globe-cities li{display:flex;align-items:baseline;gap:12px;padding:11px 0;border-top:1px solid rgba(255,255,255,.10);font-family:var(--font-m,ui-monospace,monospace);font-size:12.5px;letter-spacing:.10em;text-transform:uppercase}'
    + '.pcc-globe-cities li:last-child{border-bottom:1px solid rgba(255,255,255,.10)}'
    + '.pcc-globe-cities b{font-weight:700;color:#fff;letter-spacing:.12em}'
    + '.pcc-globe-cities i{font-style:normal;margin-left:auto;color:rgba(190,217,245,.55);font-size:11px;letter-spacing:.06em}'
    + '.pcc-globe-cities .pcc-pin{width:7px;height:7px;border-radius:50%;background:#2FE3F0;box-shadow:0 0 0 4px rgba(47,227,240,.16);flex:0 0 auto;transform:translateY(-2px)}'
    + '.pcc-globe-stage{position:relative;aspect-ratio:1/1;width:100%;max-width:520px;justify-self:center}'
    + '.pcc-globe-stage canvas{display:block;width:100%;height:100%}'
    + '@media(max-width:900px){.pcc-globe-inner{grid-template-columns:1fr;gap:34px;padding-top:clamp(48px,9vw,72px)}.pcc-globe-stage{max-width:380px;order:2}.pcc-globe-copy{order:1}}';

  function style() {
    if (document.getElementById('pccGlobeCss')) { return; }
    var s = document.createElement('style');
    s.id = 'pccGlobeCss';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function build() {
    var sec = document.createElement('section');
    sec.id = 'pccGlobe';
    sec.className = 'pcc-globe';

    var rows = CITIES.map(function (c) {
      return '<li><span class="pcc-pin"></span><b>' + c.name + '</b><i>' + c.coord + '</i></li>';
    }).join('');

    var c = copy();
    sec.innerHTML = ''
      + '<div class="pcc-globe-inner">'
      + '  <div class="pcc-globe-copy">'
      + '    <span class="pcc-globe-kicker">' + c.k + '</span>'
      + '    <h2>' + c.h + '<em>' + c.a + '</em></h2>'
      + '    <p class="pcc-globe-sub">' + c.s + '</p>'
      + '    <ul class="pcc-globe-cities">' + rows + '</ul>'
      + '  </div>'
      + '  <div class="pcc-globe-stage"><canvas id="pccGlobeCanvas" aria-hidden="true"></canvas></div>'
      + '</div>';
    return sec;
  }

  /* ---------- geometria ---------- */

  function toXYZ(lat, lon) {
    var p = lat * Math.PI / 180, l = lon * Math.PI / 180;
    return [Math.cos(p) * Math.sin(l), Math.sin(p), Math.cos(p) * Math.cos(l)];
  }

  function fibonacci(n) {
    var pts = [], ga = Math.PI * (3 - Math.sqrt(5));
    for (var i = 0; i < n; i++) {
      var y = 1 - (i / (n - 1)) * 2;
      var r = Math.sqrt(Math.max(0, 1 - y * y));
      var th = ga * i;
      pts.push([Math.cos(th) * r, y, Math.sin(th) * r]);
    }
    return pts;
  }

  function slerp(a, b, t) {
    var d = a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
    d = Math.max(-1, Math.min(1, d));
    var o = Math.acos(d);
    if (o < 1e-6) { return a.slice(); }
    var s = Math.sin(o), k1 = Math.sin((1 - t) * o) / s, k2 = Math.sin(t * o) / s;
    return [a[0] * k1 + b[0] * k2, a[1] * k1 + b[1] * k2, a[2] * k1 + b[2] * k2];
  }

  var TILT = -18 * Math.PI / 180;

  function rot(p, yaw) {
    var x = p[0] * Math.cos(yaw) + p[2] * Math.sin(yaw);
    var z = -p[0] * Math.sin(yaw) + p[2] * Math.cos(yaw);
    var y = p[1] * Math.cos(TILT) - z * Math.sin(TILT);
    var z2 = p[1] * Math.sin(TILT) + z * Math.cos(TILT);
    return [x, y, z2];
  }

  /* ---------- render ---------- */

  function run(canvas) {
    var ctx = canvas.getContext('2d');
    if (!ctx) { return; }
    var dots = fibonacci(1200);
    var pairs = [[0, 1], [1, 2], [2, 0]];
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var W = 0, H = 0, R = 0, cx = 0, cy = 0, dpr = 1;
    var yaw = -1.1, last = 0, visible = true, raf = 0;

    function size() {
      var r = canvas.getBoundingClientRect();
      if (!r.width) { return; }
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = Math.round(r.width); H = Math.round(r.height);
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      R = Math.min(W, H) * 0.38; cx = W / 2; cy = H / 2;
    }

    function project(p) { return [cx + R * p[0], cy - R * p[1], p[2]]; }

    function frame(ts) {
      raf = 0;
      if (!W) { size(); if (!W) { schedule(); return; } }
      var dt = last ? Math.min(ts - last, 60) : 16;
      last = ts;
      if (!reduced) { yaw += dt * 0.000085; }

      ctx.clearRect(0, 0, W, H);

      /* halo */
      var g = ctx.createRadialGradient(cx, cy, R * 0.55, cx, cy, R * 1.28);
      g.addColorStop(0, 'rgba(26,104,200,0.30)');
      g.addColorStop(1, 'rgba(6,22,48,0)');
      ctx.fillStyle = g;
      ctx.beginPath(); ctx.arc(cx, cy, R * 1.28, 0, 6.2832); ctx.fill();

      /* esfera */
      ctx.fillStyle = 'rgba(8,30,64,0.55)';
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, 6.2832); ctx.fill();

      /* puntos */
      for (var i = 0; i < dots.length; i++) {
        var q = rot(dots[i], yaw);
        var s = project(q);
        var front = q[2] > 0;
        var a = front ? (0.16 + 0.44 * q[2]) : (0.05 + 0.07 * (1 + q[2]));
        ctx.fillStyle = 'rgba(146,201,255,' + a.toFixed(3) + ')';
        var rad = front ? (0.7 + 1.0 * q[2]) : 0.6;
        ctx.beginPath(); ctx.arc(s[0], s[1], rad, 0, 6.2832); ctx.fill();
      }

      /* borde */
      ctx.strokeStyle = 'rgba(120,190,255,0.22)';
      ctx.lineWidth = 1;
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, 6.2832); ctx.stroke();

      /* arcos */
      var t = ts * 0.00018;
      for (var k = 0; k < pairs.length; k++) {
        var A = toXYZ(CITIES[pairs[k][0]].lat, CITIES[pairs[k][0]].lon);
        var B = toXYZ(CITIES[pairs[k][1]].lat, CITIES[pairs[k][1]].lon);
        var N = 72, prev = null;
        ctx.lineWidth = 1.4;
        for (var j = 0; j <= N; j++) {
          var u = j / N;
          var m = slerp(A, B, u);
          var lift = 1 + 0.16 * Math.sin(Math.PI * u);
          var pt = rot([m[0] * lift, m[1] * lift, m[2] * lift], yaw);
          var sp = project(pt);
          if (prev && pt[2] > -0.05 && prev[2] > -0.05) {
            ctx.strokeStyle = 'rgba(63,169,255,' + (0.10 + 0.42 * Math.max(0, pt[2])).toFixed(3) + ')';
            ctx.beginPath(); ctx.moveTo(prev[0], prev[1]); ctx.lineTo(sp[0], sp[1]); ctx.stroke();
          }
          prev = [sp[0], sp[1], pt[2]];
        }
        /* pulso viajero */
        if (!reduced) {
          var pu = (t + k / pairs.length) % 1;
          var mp = slerp(A, B, pu);
          var lf = 1 + 0.16 * Math.sin(Math.PI * pu);
          var pp = rot([mp[0] * lf, mp[1] * lf, mp[2] * lf], yaw);
          if (pp[2] > 0) {
            var ps = project(pp);
            ctx.fillStyle = 'rgba(47,227,240,0.95)';
            ctx.beginPath(); ctx.arc(ps[0], ps[1], 2.6, 0, 6.2832); ctx.fill();
            ctx.fillStyle = 'rgba(47,227,240,0.20)';
            ctx.beginPath(); ctx.arc(ps[0], ps[1], 7, 0, 6.2832); ctx.fill();
          }
        }
      }

      /* ciudades */
      ctx.font = '600 11px ui-monospace, SFMono-Regular, Menlo, monospace';
      ctx.textBaseline = 'middle';
      var vis = [];
      for (var c = 0; c < CITIES.length; c++) {
        var cp = rot(toXYZ(CITIES[c].lat, CITIES[c].lon), yaw);
        if (cp[2] <= 0.02) { continue; }
        var cs = project(cp);
        vis.push({ x: cs[0], y: cs[1], ly: cs[1], z: cp[2],
                   fade: Math.min(1, cp[2] * 3), name: CITIES[c].name.toUpperCase(), i: c });
      }
      /* separa las etiquetas cuando dos ciudades caen juntas */
      vis.sort(function (a, b) { return a.y - b.y; });
      for (var v = 1; v < vis.length; v++) {
        var gap = vis[v].ly - vis[v - 1].ly;
        if (gap < 18) { vis[v].ly = vis[v - 1].ly + 18; }
      }
      for (var v2 = 0; v2 < vis.length; v2++) {
        var m = vis[v2];
        var pulse = reduced ? 0.5 : (0.5 + 0.5 * Math.sin(ts * 0.0032 + m.i * 2.1));
        ctx.fillStyle = 'rgba(47,227,240,' + (0.10 * m.fade * pulse).toFixed(3) + ')';
        ctx.beginPath(); ctx.arc(m.x, m.y, 12 + 7 * pulse, 0, 6.2832); ctx.fill();
        ctx.fillStyle = 'rgba(47,227,240,' + (0.22 * m.fade).toFixed(3) + ')';
        ctx.beginPath(); ctx.arc(m.x, m.y, 7, 0, 6.2832); ctx.fill();
        ctx.fillStyle = 'rgba(255,255,255,' + m.fade.toFixed(3) + ')';
        ctx.beginPath(); ctx.arc(m.x, m.y, 2.8, 0, 6.2832); ctx.fill();

        var right = m.x > cx;
        var ex = right ? Math.min(m.x + 26, W - 96) : Math.max(m.x - 26, 96);
        ctx.strokeStyle = 'rgba(146,201,255,' + (0.34 * m.fade).toFixed(3) + ')';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(m.x + (right ? 10 : -10), m.y);
        ctx.lineTo(ex, m.ly);
        ctx.stroke();
        ctx.textAlign = right ? 'left' : 'right';
        ctx.fillStyle = 'rgba(232,243,255,' + (0.92 * m.fade).toFixed(3) + ')';
        ctx.fillText(m.name, right ? ex + 8 : ex - 8, m.ly);
      }

      schedule();
    }

    function schedule() {
      if (!visible || raf) { return; }
      raf = window.requestAnimationFrame(frame);
    }

    window.addEventListener('resize', function () { size(); }, { passive: true });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible) { last = 0; schedule(); }
        });
      }, { rootMargin: '120px' }).observe(canvas);
    }
    size();
    schedule();
  }

  function init() {
    try {
      if (document.getElementById('pccGlobe')) { return; }
      /* #people se retiro del tema: el ancla pasa a ser el final de #story. */
      var anchor = document.getElementById('people') || document.getElementById('story');
      if (!anchor || !anchor.parentNode) { return; }
      style();
      var sec = build();
      anchor.parentNode.insertBefore(sec, anchor.nextSibling);
      run(sec.querySelector('#pccGlobeCanvas'));
    } catch (e) {}
  }

  if (document.readyState === 'complete') {
    setTimeout(init, 250);
  } else {
    window.addEventListener('load', function () { setTimeout(init, 250); });
  }
}());
